(() => {
document.addEventListener("DOMContentLoaded", function() {
    // Radio button toggle for nomination form selection with smooth transitions
    const radioButtons = document.querySelectorAll('input[name="form-selector-radio-2026"]');
    const myselfContainer = document.querySelector('.nomination-form-container.myself');
    const someoneElseContainer = document.querySelector('.nomination-form-container.someone-else');
    if (radioButtons.length > 0 && (myselfContainer || someoneElseContainer)) {
        var block = document.querySelector('.block-nominate-2026');
        var tabbedLayout = block && block.classList.contains('block-nominate-2026--tabbed');
        function isTabbedDesktop() {
            return tabbedLayout && typeof window.matchMedia !== 'undefined' && window.matchMedia('(min-width: 769px)').matches;
        }
        var transitionMs = 400;
        function setupContainer(container) {
            if (!container) return;
            container.style.overflow = 'hidden';
            container.style.transition = 'max-height ' + transitionMs + 'ms ease-in-out, opacity ' + transitionMs * 0.6 + 'ms ease-in-out';
            container.style.maxHeight = '0';
            container.style.opacity = '0';
        }
        function showContainer(container) {
            if (!container) return;
            container.classList.add('active');
            container.style.display = 'block';
            if (isTabbedDesktop()) {
                container.style.maxHeight = '';
                container.style.opacity = '';
                container.style.transition = '';
                container.style.visibility = '';
                return;
            }
            container.style.visibility = 'hidden';
            container.style.maxHeight = 'none';
            container.style.opacity = '0';
            var height = container.scrollHeight;
            container.style.maxHeight = '0';
            container.style.visibility = '';
            container.offsetHeight;
            container.style.transition = 'max-height ' + transitionMs + 'ms ease-in-out, opacity ' + transitionMs * 0.6 + 'ms ease-in-out';
            container.style.maxHeight = height + 'px';
            container.style.opacity = '1';
            setTimeout(function() {
                if (container.style.opacity === '1') container.style.maxHeight = 'none';
            }, transitionMs + 50);
        }
        function hideContainer(container) {
            if (!container) return;
            if (isTabbedDesktop()) {
                container.classList.remove('active');
                container.style.display = 'none';
                container.style.maxHeight = '';
                container.style.opacity = '';
                container.style.transition = '';
                container.style.visibility = '';
                return;
            }
            var height = container.scrollHeight;
            container.style.maxHeight = height + 'px';
            container.offsetHeight;
            container.style.maxHeight = '0';
            container.style.opacity = '0';
            setTimeout(function() {
                if (container.style.opacity === '0') {
                    container.classList.remove('active');
                    container.style.display = 'none';
                    container.style.visibility = '';
                }
            }, transitionMs + 50);
        }
        // Initialize containers
        setupContainer(myselfContainer);
        setupContainer(someoneElseContainer);
        radioButtons.forEach(function(radio) {
            radio.addEventListener('change', function() {
                console.log('[LDC Nominate 2026] Form selector changed:', this.value);
                // Remove active class from all selector items
                document.querySelectorAll('.form-selector-item').forEach(function(item) {
                    item.classList.remove('active');
                });
                // Add active class to the parent list item of the selected radio
                const parentListItem = this.closest('.form-selector-item');
                if (parentListItem) parentListItem.classList.add('active');
                if (this.value === 'Myself') {
                    showContainer(myselfContainer);
                    hideContainer(someoneElseContainer);
                } else if (this.value === 'Someone else') {
                    showContainer(someoneElseContainer);
                    hideContainer(myselfContainer);
                }
            });
        });
        // If a radio is already checked, show that form
        const checkedRadio = document.querySelector('input[name="form-selector-radio-2026"]:checked');
        if (checkedRadio) checkedRadio.dispatchEvent(new Event('change'));
    }
    // Character count for fields with maxlength (incl. D365-injected fields)
    function attachCharCountToField(input) {
        if (!input || !input.getAttribute || !input.getAttribute("maxlength")) return;
        if (input.closest && input.closest(".word-count-textarea-wrapper")) return;
        var maxChars = parseInt(input.getAttribute("maxlength"), 10) || 0;
        if (maxChars <= 0) return;
        var wrapper = document.createElement("div");
        wrapper.className = "word-count-textarea-wrapper";
        input.parentNode.insertBefore(wrapper, input);
        wrapper.appendChild(input);
        var counter = document.createElement("div");
        counter.className = "word-count-indicator";
        counter.setAttribute("aria-live", "polite");
        wrapper.appendChild(counter);
        var lowThreshold = 50;
        function updateCharCount() {
            var current = (input.value || "").length;
            var remaining = Math.max(0, maxChars - current);
            counter.textContent = current + " / " + maxChars + " characters";
            counter.style.opacity = current > 0 ? "1" : "0.25";
            if (remaining <= lowThreshold && current > 0) counter.classList.add("word-count-indicator--low");
            else counter.classList.remove("word-count-indicator--low");
        }
        input.addEventListener("input", updateCharCount);
        input.addEventListener("change", updateCharCount);
        updateCharCount();
    }
    function setupCharCounters() {
        var block = document.querySelector(".block-nominate-2026");
        if (!block) return;
        block.querySelectorAll(".word-count-field textarea, textarea[maxlength]").forEach(attachCharCountToField);
    }
    setupCharCounters();
    // Re-run after delay so D365-injected form fields get counters
    setTimeout(setupCharCounters, 2000);
    setTimeout(setupCharCounters, 5000);
    // D365 Form initialization for nomination forms
    // Wait for FormLoader to be available, then ensure all forms are initialized
    function initializeD365Forms() {
        if (typeof MsCrmMkt === 'undefined' || typeof MsCrmMkt.MsCrmFormLoader === 'undefined') {
            // FormLoader not loaded yet, wait a bit longer
            setTimeout(initializeD365Forms, 100);
            return;
        }
        console.log('[LDC Nominate 2026] D365 FormLoader detected, checking forms...');
        // Find all D365 form containers
        var formContainers = document.querySelectorAll('.block-nominate-2026 .embed_form[data-form-id]');
        if (formContainers.length > 0) {
            console.log('[LDC Nominate 2026] Found ' + formContainers.length + ' D365 form(s), ensuring initialization...');
            // Sometimes forms that are hidden (display: none) don't initialize
            // Make sure they're visible during initialization
            formContainers.forEach(function(container) {
                var formWrapper = container.closest('.nomination-form-container');
                if (formWrapper) {
                    var wasHidden = formWrapper.style.display === 'none';
                    if (wasHidden) {
                        // Temporarily show for initialization
                        formWrapper.style.display = 'block';
                        formWrapper.style.visibility = 'hidden';
                        formWrapper.style.position = 'absolute';
                        // Hide again after a brief moment
                        setTimeout(function() {
                            formWrapper.style.display = '';
                            formWrapper.style.visibility = '';
                            formWrapper.style.position = '';
                        }, 500);
                    }
                }
            });
        }
    }
    // Start checking for FormLoader after a brief delay
    setTimeout(initializeD365Forms, 500);
    // --- Form steps (split by section headings, show one step at a time) ---
    var blockWithSteps = document.querySelector('.block-nominate-2026[data-use-steps="1"]');
    if (blockWithSteps) {
        var stepsPollCount = 0;
        var stepsPollMax = 80; // 40s at 500ms (D365 can load slowly)
        function getFormInner(embedEl) {
            return embedEl.querySelector('.marketingForm') || embedEl.querySelector('.marketing-form') || embedEl.querySelector('form') || (embedEl.children.length > 0 ? embedEl.children[0] : null);
        }
        function tryBuildFormSteps() {
            stepsPollCount++;
            blockWithSteps.querySelectorAll('.embed_form[data-form-id]').forEach(function(embedEl) {
                if (embedEl.hasAttribute('data-steps-built')) return;
                var formInner = getFormInner(embedEl);
                if (!formInner || !formInner.querySelector) return;
                var sections = Array.from(formInner.querySelectorAll('[data-section="true"]'));
                if (sections.length === 0) return;
                var headings = formInner.querySelectorAll('h1, h2, h3');
                var headingSections = [];
                for(var h = 0; h < headings.length; h++){
                    var sec = headings[h].closest('[data-section="true"]');
                    if (sec && headingSections.indexOf(sec) === -1) headingSections.push(sec);
                }
                if (headingSections.length === 0) {
                    if (stepsPollCount === 3) console.log("[LDC Nominate 2026] Form steps: no h1/h2/h3 found inside sections \u2013 ensure your D365 form has section headings.");
                    return;
                }
                embedEl.setAttribute('data-steps-built', '1');
                buildFormStepsFromSections(embedEl, formInner, sections, headingSections);
                console.log('[LDC Nominate 2026] Form steps built (by h1/h2/h3 in sections)');
            });
            if (stepsPollCount < stepsPollMax) setTimeout(tryBuildFormSteps, 500);
        }
        setTimeout(tryBuildFormSteps, 1500);
        // When user switches tab, build steps for the now-visible form after the tab transition finishes (avoids glitchy mid-animation DOM changes)
        var tabTransitionMs = 450;
        if (radioButtons && radioButtons.length) radioButtons.forEach(function(radio) {
            radio.addEventListener('change', function() {
                setTimeout(function() {
                    var visible = document.querySelector('.nomination-form-container.active .embed_form[data-form-id]');
                    if (visible && !visible.hasAttribute('data-steps-built')) {
                        var formInner = getFormInner(visible);
                        if (formInner && formInner.querySelector) {
                            var sections = Array.from(formInner.querySelectorAll('[data-section="true"]'));
                            if (sections.length > 0) {
                                var headings = formInner.querySelectorAll('h1, h2, h3');
                                var headingSections = [];
                                for(var h = 0; h < headings.length; h++){
                                    var sec = headings[h].closest('[data-section="true"]');
                                    if (sec && headingSections.indexOf(sec) === -1) headingSections.push(sec);
                                }
                                if (headingSections.length > 0) {
                                    visible.setAttribute('data-steps-built', '1');
                                    buildFormStepsFromSections(visible, formInner, sections, headingSections);
                                }
                            }
                        }
                    }
                }, tabTransitionMs);
            });
        });
    }
    function buildFormStepsFromSections(embedEl, formInner, sections, headingSections) {
        var idx = [];
        for(var i = 0; i < headingSections.length; i++)idx.push(sections.indexOf(headingSections[i]));
        var appendTarget = sections[0].parentNode;
        var steps = [];
        var stepIndex = 0;
        if (idx[0] > 0) {
            var stepDiv = document.createElement('div');
            stepDiv.className = 'form-step';
            stepDiv.setAttribute('data-step-index', '1');
            stepDiv.style.display = 'block';
            if (appendTarget.insertBefore) appendTarget.insertBefore(stepDiv, sections[0]);
            else appendTarget.appendChild(stepDiv);
            for(var i = 0; i < idx[0]; i++)stepDiv.appendChild(sections[i]);
            steps.push(stepDiv);
            stepIndex++;
        }
        for(var s = 0; s < headingSections.length; s++){
            var from = idx[s];
            var to = s + 1 < headingSections.length ? idx[s + 1] : sections.length;
            var stepDiv = document.createElement('div');
            stepDiv.className = 'form-step';
            stepDiv.setAttribute('data-step-index', String(stepIndex + 1));
            stepDiv.style.display = steps.length === 0 ? 'block' : 'none';
            if (appendTarget.insertBefore) appendTarget.insertBefore(stepDiv, sections[from]);
            else appendTarget.appendChild(stepDiv);
            for(var i = from; i < to; i++)stepDiv.appendChild(sections[i]);
            steps.push(stepDiv);
            stepIndex++;
        }
        if (steps.length <= 1) return;
        var total = steps.length;
        var nav = document.createElement('div');
        nav.className = 'form-steps-nav';
        nav.setAttribute('aria-label', 'Form steps');
        var indicator = document.createElement('div');
        indicator.className = 'form-steps-indicator';
        indicator.innerHTML = 'Step <span class="form-steps-current">1</span> of <span class="form-steps-total">' + total + '</span>';
        var fullFormBtn = document.createElement('button');
        fullFormBtn.type = 'button';
        fullFormBtn.className = 'form-steps-full-toggle';
        fullFormBtn.setAttribute('aria-label', 'Show all entry steps');
        fullFormBtn.textContent = 'All steps';
        nav.appendChild(indicator);
        nav.appendChild(fullFormBtn);
        embedEl.insertBefore(nav, embedEl.firstChild);
        var current = 0;
        var isFullView = false;
        function showStep(idx) {
            current = idx;
            steps.forEach(function(step, i) {
                step.style.display = i === idx ? 'block' : 'none';
            });
            indicator.querySelector('.form-steps-current').textContent = String(idx + 1);
            var activeStep = steps[idx];
            if (activeStep && activeStep.scrollIntoView) activeStep.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
        function goPrev() {
            if (current > 0) showStep(current - 1);
        }
        function goNext() {
            if (current < total - 1) showStep(current + 1);
        }
        function setFullView(full) {
            isFullView = full;
            embedEl.setAttribute('data-steps-full-view', full ? '1' : '0');
            embedEl.classList.toggle('form-steps-full-view', full);
            if (full) {
                steps.forEach(function(step) {
                    step.style.display = 'block';
                });
                indicator.style.display = 'none';
                fullFormBtn.setAttribute('aria-label', 'Step by step');
                fullFormBtn.textContent = 'Step by step';
                fullFormBtn.classList.add('is-full-view');
            } else {
                showStep(current);
                indicator.style.display = '';
                fullFormBtn.setAttribute('aria-label', 'Show all entry steps');
                fullFormBtn.textContent = 'Show all';
                fullFormBtn.classList.remove('is-full-view');
            }
        }
        fullFormBtn.addEventListener('click', function() {
            setFullView(!isFullView);
        });
        steps.forEach(function(step, i) {
            var footer = document.createElement('div');
            footer.className = 'form-step-footer';
            if (i > 0) {
                var prevBottom = document.createElement('button');
                prevBottom.type = 'button';
                prevBottom.className = 'form-steps-prev-bottom button --accent';
                prevBottom.textContent = 'Previous';
                prevBottom.addEventListener('click', goPrev);
                footer.appendChild(prevBottom);
            }
            if (i < total - 1) {
                var nextBottom = document.createElement('button');
                nextBottom.type = 'button';
                nextBottom.className = 'form-steps-next-bottom button --accent';
                nextBottom.textContent = 'Next';
                nextBottom.addEventListener('click', goNext);
                footer.appendChild(nextBottom);
            }
            step.appendChild(footer);
        });
        /* Step-by-step submit: run before D365 by listening on the container in capture phase (event reaches embedEl before the form). */ var form = embedEl.querySelector('form');
        if (form) form.setAttribute('novalidate', '');
        /* Use embedEl so we catch input/change from all fields (D365 fields may be outside the form element) */ embedEl.addEventListener('input', function(e) {
            if (e.target.matches && e.target.matches('input, textarea, select')) e.target.classList.remove('form-field-error');
        }, false);
        embedEl.addEventListener('change', function(e) {
            if (e.target.matches && e.target.matches('input, textarea, select')) e.target.classList.remove('form-field-error');
        }, false);
        if (form) {
            var allowNextSubmitToD365 = false;
            embedEl.addEventListener('submit', function onStepFormSubmit(e) {
                if (e.target !== form) return;
                if (allowNextSubmitToD365) {
                    allowNextSubmitToD365 = false;
                    e.preventDefault();
                    return;
                }
                e.preventDefault();
                e.stopPropagation();
                if (!isFullView) setFullView(true);
                requestAnimationFrame(function() {
                    embedEl.classList.remove('form-showing-validation-errors');
                    if (form) form.classList.remove('form-showing-validation-errors');
                    embedEl.querySelectorAll('.form-field-error').forEach(function(el) {
                        el.classList.remove('form-field-error');
                    });
                    var valid = form ? form.reportValidity() : false;
                    if (valid) {
                        allowNextSubmitToD365 = true;
                        form.dispatchEvent(new Event('submit', {
                            bubbles: true,
                            cancelable: true
                        }));
                    } else {
                        /* Query from embedEl: D365 fields may live in .marketingForm, not necessarily inside the form element */ var invalidFields = embedEl.querySelectorAll('input:invalid, textarea:invalid, select:invalid');
                        invalidFields.forEach(function(el) {
                            el.classList.add('form-field-error');
                        });
                        embedEl.classList.add('form-showing-validation-errors');
                        if (form) form.classList.add('form-showing-validation-errors');
                        var firstInvalid = invalidFields[0];
                        if (firstInvalid && firstInvalid.scrollIntoView) firstInvalid.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                        var banner = embedEl.querySelector('.form-steps-error-banner');
                        if (!banner) {
                            banner = document.createElement('div');
                            banner.className = 'form-steps-error-banner';
                            banner.setAttribute('role', 'alert');
                            banner.textContent = 'Please fix the errors below before submitting.';
                            embedEl.insertBefore(banner, nav.nextSibling);
                            setTimeout(function() {
                                if (banner.parentNode) banner.remove();
                            }, 8000);
                        }
                    }
                });
            }, true);
        }
        /* If D365 injects error messages after submit, reveal them (full form + scroll) */ var errorObserver = new MutationObserver(function(mutations) {
            if (isFullView) return;
            for(var m = 0; m < mutations.length; m++){
                var list = mutations[m].addedNodes;
                for(var n = 0; n < list.length; n++){
                    var node = list[n];
                    if (node.nodeType !== 1) continue;
                    var hasError = node.classList && node.classList.contains('lp-form-message') || node.getAttribute && node.getAttribute('data-submissionresponse') === 'error' || node.querySelector && node.querySelector('.lp-form-message, [data-submissionresponse="error"]');
                    if (hasError) {
                        setFullView(true);
                        var target = node.classList && node.classList.contains('lp-form-message') ? node : node.querySelector('.lp-form-message') || node;
                        if (target && target.scrollIntoView) target.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                        errorObserver.disconnect();
                        return;
                    }
                }
            }
        });
        errorObserver.observe(embedEl, {
            childList: true,
            subtree: true
        });
        showStep(0);
    }
    // When D365 shows thank you message: collapse form space, strip inline dimensions (e.g. 931×848), scroll into view (block-specific UI)
    var blockEl = document.querySelector('.block-nominate-2026');
    if (blockEl) {
        var embedForms = blockEl.querySelectorAll('.embed_form[data-form-id]');
        function applyThankYouUI(thankYouElement) {
            var formSection = thankYouElement.closest('.expandable_form__form');
            var embedForm = thankYouElement.closest('.embed_form');
            if (formSection) formSection.classList.add('form-submitted-success');
            if (embedForm) embedForm.classList.add('form-submitted-success');
            var el = thankYouElement;
            for(var i = 0; i < 3 && el; i++){
                if (el.style && (el.style.height || el.style.width)) {
                    el.style.removeProperty('height');
                    el.style.removeProperty('width');
                }
                el = el.parentElement;
            }
            thankYouElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
        embedForms.forEach(function(embedEl) {
            var successObserver = new MutationObserver(function(mutations) {
                for(var m = 0; m < mutations.length; m++){
                    var list = mutations[m].addedNodes;
                    for(var n = 0; n < list.length; n++){
                        var node = list[n];
                        if (node.nodeType !== 1) continue;
                        var thankYou = node.classList && node.classList.contains('onFormSubmittedFeedbackMessage') ? node : node.querySelector && node.querySelector('.onFormSubmittedFeedbackMessage');
                        if (!thankYou) continue;
                        var isError = thankYou.querySelector && thankYou.querySelector('[data-submissionresponse="error"]') || thankYou.classList && thankYou.classList.contains('error');
                        if (isError) continue;
                        applyThankYouUI(thankYou);
                        successObserver.disconnect();
                        return;
                    }
                }
            });
            successObserver.observe(embedEl, {
                childList: true,
                subtree: true
            });
        });
    }
});

})();
//# sourceMappingURL=nominate-form-2026.js.map
